import {
	SET_GUESTS,
	SET_GUEST,
	CLEAR_GUESTS,
	CLEAR_GUEST,
	ADD_GUEST,
	UPDATE_GUEST,
	REMOVE_GUEST,
} from './actionTypes';

export const guest = (state = {}, action) => {
	switch (action.type) {
		case SET_GUEST:
			return action.payload;
		case UPDATE_GUEST:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_GUEST:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_GUESTS:
			return action.payload;
		case ADD_GUEST:
			return [...state, action.payload];
		case UPDATE_GUEST:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_GUEST:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_GUESTS:
			return [];
		default:
			return state;
	}
};
